module.exports = __webpack_public_path__ + "img/bus-w.36d97309.png";